import "./App.css";
import Background from "./components/Background/Background";

function App() {
  return (
    
      <div>
        <Background></Background>
      </div>
    
  );
}

export default App;
